import { createSlice } from "@reduxjs/toolkit";

const cartSlice = createSlice({
    name: "cart",
    initialState: {
        items: [],
    },
    reducers: {
        addItem: (state, action) => {
            const existing = state.items.find((i) => i.id === action.payload.id);
            if (existing) {
                existing.quantity += 1;
            } else {
                state.items.push({ ...action.payload, quantity: 1 });
            }
        },
        removeItem: (state, action) => {
            const index = state.items.findIndex((i) => i.id === action.payload);
            if (index === -1) return;
            if (state.items[index].quantity > 1) {
                state.items[index].quantity -= 1;
            } else {
                state.items.splice(index, 1);
            }
        },
        clearCart: (state, action) => {
            state.items.length = 0; //[]
        },
    },
});
export const { addItem, removeItem, clearCart } = cartSlice.actions;
export default cartSlice.reducer;
